<div class="right-side p-5">
  <h2>List of Attended MSMEs</h2>
  <div class="section">
    <div class="row">
      <div class="text-end">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">
          <i class="bi bi-file-earmark-excel"></i> Export To Excel
        </button>
      </div>

      <div class="col-lg-7 col-sm-12">
        <div class="search-container">
          <form [formGroup]="form">
            <mat-form-field class="search-input w-75" appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput formControlName="searchControl" />
            </mat-form-field>
            <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form.get('searchControl')?.value ?? '')" id="btnSearch">
              <i class="bi bi-search fs-4"></i>
            </button>
            <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
              <i class="bi bi-arrow-clockwise fs-4"></i>
            </button>

          </form>
        </div>
      </div>
    </div>


    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="UdyamRegistrationNumber" matSort matSortDirection="asc" matSortDisableClear>
        <ng-container matColumnDef="Sr.No">
          <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
          <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
        </ng-container>
        <ng-container matColumnDef="UdyamRegistrationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Registration Number</th>
          <td mat-cell *matCellDef="let gr"> {{gr.udyamRegistrationNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="OwnersMobileNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number Registered with Udyam</th>
          <td mat-cell *matCellDef="let gr"> {{gr.ownersMobileNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="IsRAMPRegistered">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Is User Registered on RAMP</th>
          <td mat-cell *matCellDef="let gr"> {{gr.isRAMPRegistered ? 'Yes': 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="RegistrationType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Registration Type</th>
          <td mat-cell *matCellDef="let gr"> {{gr.registrationType }} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let gr">
            <button class="btn btn-primary btn-sm me-2" (click)="onVerifyMSME(gr.udyamRegistrationNumber,gr.ownersMobileNumber)" *ngIf="!gr.isRAMPRegistered">
              Verify MSME
            </button>
            <label *ngIf="gr.isRAMPRegistered">No Action</label>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        Row shown when there is no matching data.
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>
        </tr>
      </table>

    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>
  </div>

  <button type="submit" class="btn btn-info" (click)="onPressBack()">Back</button>
</div>



